import { client } from '@cockpitai/lib/api.ts'
import {
  TChatResponse,
  THistoryChatByChatIdResponse,
  TMessageHistory,
} from './types'

export function sendChat({
  message,
  chat_id,
}: {
  message: string
  chat_id?: number
}) {
  return client.post<TChatResponse>('/chat', {
    question: message,
    chat_id,
    timeout: 120 * 1000,
  })
}

export function getHistory() {
  return client
    .get<TMessageHistory[]>('/chat')
    .then((response) => response.data)
}

export function getHistoryByChatId(historyChatId?: number) {
  return client
    .get<THistoryChatByChatIdResponse>(`/chat/${historyChatId}/history`)
    .then((response) => response.data)
}

export function ratingMessage({
  chatId,
  messageId,
  like,
  text
}: {
  chatId: number
  messageId: number
  like: boolean
  text: string
}) {
  return client.patch<TChatResponse>(`chat/${chatId}/message/${messageId}`, {
    like,
    text
  })
}
